var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFestivalier(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "badgeStatus",
    d: "M103.844 52.7823L125.082 89.4831C135.751 107.917 122.413 130.957 101.074 130.957L58.5985 130.957C37.26 130.957 23.922 107.917 34.5913 89.4831L55.8292 52.7823C66.4985 34.3483 93.1688 34.3483 103.838 52.7823L103.844 52.7823Z",
    fill: "#00D1D2",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "badgeStroke",
    d: "M129.65 89.97L129.65 89.9701C141.295 110.14 126.737 135.35 103.447 135.35L55.5531 135.35C32.2625 135.35 17.7047 110.14 29.3498 89.9701L29.3499 89.97L53.2967 48.4848C53.2967 48.4848 53.2967 48.4847 53.2967 48.4847C64.942 28.3144 94.0518 28.3144 105.697 48.4848L105.986 48.9848L105.992 48.9848L129.65 89.97Z",
    stroke: "#00D1D2",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.115 108.36V106.16",
    stroke: "#34303D",
    strokeWidth: 4.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.115 119.33V117.13",
    stroke: "#34303D",
    strokeWidth: 4.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.495 112.75H124.695",
    stroke: "#34303D",
    strokeWidth: 4.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.535 112.75H113.725",
    stroke: "#34303D",
    strokeWidth: 4.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.955 75.1999V73.6899",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.955 82.76V81.25",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.975 78.23H48.485",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.415 78.23H40.925",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.925 91.53L47.825 95.62H47.315C46.715 95.8 45.805 96.08 44.685 96.42C43.905 96.65 43.015 96.91 43.015 96.91L38.565 98.24V94.31L47.925 91.53Z",
    fill: "#FFFDFB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.215 108.68C46.4742 108.68 47.495 107.659 47.495 106.4C47.495 105.141 46.4742 104.12 45.215 104.12C43.9558 104.12 42.935 105.141 42.935 106.4C42.935 107.659 43.9558 108.68 45.215 108.68Z",
    fill: "#FFFDFB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.215 106.77C37.465 106.77 38.485 107.79 38.485 109.05C38.485 110.31 37.465 111.32 36.215 111.32C34.965 111.32 33.935 110.3 33.935 109.05C33.935 107.8 34.955 106.77 36.215 106.77Z",
    fill: "#FFFDFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.485 109.05C38.485 110.3 37.465 111.32 36.215 111.32C34.965 111.32 33.935 110.3 33.935 109.05C33.935 107.8 34.955 106.77 36.215 106.77C37.475 106.77 38.485 107.79 38.485 109.05Z",
    stroke: "#34303D",
    strokeWidth: 1.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.215 108.68C46.4742 108.68 47.495 107.659 47.495 106.4C47.495 105.141 46.4742 104.12 45.215 104.12C43.9558 104.12 42.935 105.141 42.935 106.4C42.935 107.659 43.9558 108.68 45.215 108.68Z",
    stroke: "#34303D",
    strokeWidth: 1.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.565 109.05V98.24V94.31L47.925 91.53L47.825 95.62L47.565 106.4",
    stroke: "#34303D",
    strokeWidth: 1.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.565 98.2401L43.015 96.9101C43.015 96.9101 43.905 96.6501 44.685 96.4201C45.805 96.0801 46.715 95.8001 47.315 95.6101",
    stroke: "#34303D",
    strokeWidth: 1.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.725 90.9202C116.845 90.9202 117.755 91.8202 117.755 92.9402C117.755 94.0602 116.845 94.9702 115.725 94.9702C114.605 94.9702 113.695 94.0602 113.695 92.9402C113.695 91.8202 114.605 90.9202 115.725 90.9202Z",
    fill: "#FFFDFB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.755 92.9402C117.755 94.0602 116.845 94.9702 115.725 94.9702C114.605 94.9702 113.695 94.0602 113.695 92.9402C113.695 91.8202 114.605 90.9202 115.725 90.9202C116.845 90.9202 117.755 91.8202 117.755 92.9402Z",
    stroke: "#34303D",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M124.255 77.8801C124.305 79.0101 124.355 80.1401 124.415 81.2701C123.535 81.5601 122.655 81.8501 121.755 82.1401C120.425 82.5601 119.105 82.9601 117.805 83.3501L117.785 79.8501C119.945 79.1901 122.095 78.5301 124.255 77.8801Z",
    fill: "#FFFDFB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.805 83.3501L117.785 79.8501C119.945 79.1901 122.095 78.5301 124.255 77.8801C124.305 79.0101 124.355 80.1401 124.415 81.2701C123.535 81.5601 122.655 81.8501 121.755 82.1401C120.425 82.5601 119.105 82.9601 117.805 83.3501Z",
    stroke: "#34303D",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.875 92.9601L117.805 83.3501",
    stroke: "#34303D",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95.215 112.43C95.225 112.7 95.245 112.98 95.275 113.26C95.665 119.12 96.055 124.96 96.445 130.82C86.085 130.88 75.745 130.93 65.385 130.98C65.385 125.81 65.385 120.64 65.385 115.48C65.385 114.37 65.385 113.27 65.385 112.17",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.365 115.55C65.455 113.43 65.425 110.29 64.725 106.59C63.905 102.26 62.605 99.43 61.645 97.1C57.105 86.12 54.145 79.15 56.755 73.34C56.885 73.05 58.825 69.42 64.085 63.26C64.565 62.7 65.055 62.12 65.665 61.7C67.055 60.72 68.855 60.6 70.555 60.51C74.515 60.31 78.465 60.11 82.425 59.91C83.635 59.85 84.885 59.79 86.035 60.18C87.185 60.57 88.235 61.52 88.365 62.73C88.485 63.85 87.825 64.9 87.105 65.76C82.265 71.53 74.155 73.13 66.665 73.89C69.265 75.05 73.495 77.33 77.455 81.59C81.945 86.42 83.925 91.46 84.805 94.28",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.605 62.2101C63.365 52.5101 62.395 45.3901 61.775 40.9801C60.905 34.7001 60.125 29.3701 62.865 27.4901C63.935 26.7501 65.415 26.6401 66.555 27.0301C69.715 28.1301 70.555 33.2201 71.025 36.0401C72.215 43.2201 73.595 51.1601 75.155 60.2701",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.095 64.19C98.975 63.73 98.165 60.87 95.785 60.07C94.225 59.55 92.715 60.15 92.395 60.27C91.315 60.69 90.475 61.55 89.725 62.42C86.565 66.05 84.145 70.32 82.665 74.89C82.025 76.85 81.615 79.18 82.825 80.85C84.165 82.69 87.605 82.21 89.675 81.31C90.385 81 91.885 80.22 95.035 75.06C98.265 69.78 99.855 67.08 99.095 64.2V64.19Z",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M105.275 70.38C104.205 69.24 102.545 69.24 102.235 69.24C99.335 69.24 97.185 72.4 92.875 78.72C92.315 79.54 91.585 80.83 91.395 82.59C91.245 83.97 91.605 85.47 92.615 86.43C94.055 87.8 95.995 87.84 96.355 87.83C101.045 87.67 103.945 80.69 104.605 79.08C105.445 77.06 107.305 72.55 105.275 70.38Z",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M103.365 81.76C103.575 86.51 102.615 89.88 101.695 92.1C100.875 94.06 100.075 94.82 98.415 98.4C97.345 100.72 96.555 102.41 95.975 104.59C95.475 106.47 94.945 109.43 95.275 113.27",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.495 60.1501C79.045 51.5101 80.405 43.9501 81.595 37.0801C82.085 34.2601 82.955 29.1801 86.125 28.1001C87.275 27.7101 88.755 27.8401 89.815 28.5901C92.545 30.4901 91.735 35.8101 90.815 42.0801C90.195 46.2601 89.255 52.8501 88.045 61.7701",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.015 117.53C97.095 117.53 98.775 119.22 98.775 121.3C98.775 122.34 98.355 123.28 97.675 123.96C96.995 124.64 96.055 125.06 95.015 125.06H64.995C62.915 125.06 61.225 123.38 61.225 121.3C61.225 120.26 61.645 119.32 62.325 118.64C63.005 117.96 63.955 117.53 64.995 117.53H95.015Z",
    fill: "#FFFDFB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M95.015 125.06H64.995C62.915 125.06 61.225 123.38 61.225 121.3C61.225 120.26 61.645 119.32 62.325 118.64C63.005 117.96 63.955 117.53 64.995 117.53H95.015C97.095 117.53 98.775 119.22 98.775 121.3C98.775 122.34 98.355 123.28 97.675 123.96C96.995 124.64 96.055 125.06 95.015 125.06Z",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.235 119.04H56.405V123.87H61.235V119.04Z",
    fill: "#FFFDFB",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50.645 115.55C52.565 116.71 54.485 117.88 56.405 119.04V123.87C54.365 124.63 52.315 125.39 50.275 126.15C50.395 122.62 50.525 119.08 50.645 115.55Z",
    fill: "#FFFDFB",
    stroke: "#34303D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFestivalier);
export default __webpack_public_path__ + "static/media/festivalier.c87593b8047e18081b92d9e3f21d0715.svg";
export { ForwardRef as ReactComponent };